import { createApp, ref } from 'vue';
import App from './App.vue';
import FloatingVue from 'floating-vue';
import router from './router';
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/core.scss';
import 'floating-vue/dist/style.css';
import '@vueform/toggle/themes/default.css';
import '@vueform/multiselect/themes/default.css';

// required for webpack file loader
require('../favicon.ico');

// API Endpoints
const globalApiEndPoints = ref({
  apiUrlPostcode: 'https://www.johanniterhausnotruf.de/df_pc.php',
  apiUrlStreet: 'https://www.johanniterhausnotruf.de/df_street.php',
});

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Tooltip settings
FloatingVue.options.themes.tooltip.delay.show = 0;
FloatingVue.options.themes.tooltip.triggers = ['hover', 'click'];

app.provide('globalApiEndPoints', globalApiEndPoints);

app.use(router);
app.use(FloatingVue);
app.use(pinia);
app.mount('#app');
